import { IShoppingCartProduct } from '@monofront/types';

type IGroupProducts = Record<string, IShoppingCartProduct[]>;

export interface ISortProductByType {
  label: string;
  products: IShoppingCartProduct[];
  productsQuantity: number;
}

const groupCartProductsByType = (
  shoppingCartProducts: IShoppingCartProduct[],
  fallBackLabel: string,
) => {
  if (!shoppingCartProducts?.length) return [];

  const groupCartProductByType: IGroupProducts = shoppingCartProducts.reduce(
    (groupedProducts: IGroupProducts, product) => {
      const productType = product.product_type || (fallBackLabel ?? '');

      if (!groupedProducts[productType]) {
        groupedProducts[productType] = [];
      }
      groupedProducts[productType].push(product);

      return groupedProducts;
    },
    {},
  );

  return groupCartProductByType;
};

const formatGroups = (
  shoppingCartProduct: IShoppingCartProduct[],
  fallBackLabel: string,
): ISortProductByType[] => {
  const groupCartProductByType = groupCartProductsByType(
    shoppingCartProduct,
    fallBackLabel,
  );

  return Object.entries(groupCartProductByType).map(([label, products]) => ({
    productsQuantity: products.reduce(
      (accumulator, product) => accumulator + product.quantity,
      0,
    ),
    products,
    label,
  }));
};

export default formatGroups;
